module.exports = __webpack_public_path__ + "img/jb.d5f734c4.png";